import React from 'react';
import { useTranslation } from 'react-i18next';
import Header from './Header';
import '../../assets/stylesheets/Units/HelpPage.scss';



const HelpPage = ({ items }) => {
    const { t } = useTranslation();

    const renderItem = ([title, description]) => (
        <li key={title} className="helper">
            <header className="helperHeader">{t(`clubDataHelp.${title}`)}</header>
            <p className="helperDescription">{t(`clubDataHelp.${description}`)}</p>
        </li>
    );

    return (
        <div className="helpPage">
            <Header
                title="information"
                className="dialogHeader--gray"
            />
            <ul className="helpers">
                {items.map(renderItem)}
            </ul>
        </div>
    );
}

export default HelpPage;